// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"6b4f3f05","520":"40ae6eee","570":"ab7e4d81","860":"72608a59","947":"9216df8e"}[chunkId] + ".chunk.css";
};